<ng-container *ngIf="modal">
  <app-confirm-modal-template [modal]="modal">
    <div preModalBody class="meta-bar px-3 py-2">
      <div class="container">
        <div class="row">
          <div *ngIf="roster" class="col-auto py-2">
            <div class="title">{{ roster.name }}</div>
            <div class="sub-title">
              <span *ngIf="roster.source === uploadFileTypes.Manual"> {{ 'MANUAL' | translate }}</span>
              <span *ngIf="roster.source === uploadFileTypes.Automatic"> {{ 'SERVER_FILE' | translate }}</span>
              <span *ngIf="roster.source === uploadFileTypes.GroupOfGroups"> {{ 'GROUP_OF_GROUPS' | translate }}</span>
            </div>
          </div>
          <div class="col-auto ml-auto py-2 text-right">
            <span class="d-flex align-items-center ml-auto">
              <i class="ftmi-group icon"></i>
              {{ roster?.membershipCount }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div modalBody>
      <div class="mh-sm">
        <ul class="list-group">
          <li *ngFor="let item of roster?.membershipCollection" class="list-group-item">
            <b class="mr-3">{{ item?.user?.firstName }} {{ item?.user?.lastName }}</b>
            {{ item?.user?.email }}
          </li>
        </ul>
      </div>
    </div>
  </app-confirm-modal-template>
</ng-container>
